import { Injectable, Inject } from '@angular/core';
import { IExpenseItem } from './IExpenseItem';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ExpenseItemLookupService {

  constructor(@Inject(HttpClient) private http: HttpClient
    , @Inject(LoggingService) private log: LoggingService) {
  }
  uri = `${environment.apiLocation}/ExpenseItem`;

  public get (): Observable<Array<IExpenseItem>> {
    const params = {};

    this.log.verbose({ type: 'ExpenseItemLookupService:get', uri: this.uri });
    return this.http.get<Array<IExpenseItem>>(this.uri)
      .pipe(
        tap(res => this.log.verbose({ type: 'ExpenseItemLookupService:reponse', res }))
      );
  }
}
